import React from "react";
import "../css/FleetSlider.css";

const FleetSlider = () => {
  return (
    <div className="fleet-section">
      {/* <h2 className="fleet-title">Our Fleets</h2> */}
      <div className="car-slider">
        <div className="car-track">
          <img src="/images/gallery/1.jpg" alt="Innova Crysta" />
          <img src="/images/gallery/2.jpg" alt="Innova Crysta" />
          <img src="/images/gallery/3.jpg" alt="Innova Crysta" />
          <img src="/images/gallery/4.jpg" alt="Innova Crysta" />
          <img src="/images/gallery/5.jpg" alt="Innova Crysta" />
          <img src="/images/gallery/6.jpg" alt="Innova Crysta" />
       
          {/* Duplicate for smooth infinite loop */}
          {/* <img src="/images/innova.png" alt="Innova Crysta" />
          <img src="/images/ertiga.png" alt="Ertiga" />
          <img src="/images/dzire.png" alt="Swift Dzire" />
          <img src="/images/kia.png" alt="Kia Carens" />
          <img src="/images/urbania.png" alt="Urbania" />
          <img src="/images/tempo.png" alt="Tempo Traveller" /> */}
        </div>
      </div>
    </div>
  );
};

export default FleetSlider;
